export function validateReturnUrl(returnUrl?: string) {
    if (!returnUrl) {
        return false;
    }

    if (returnUrl === '/') {
        return true;
    }

    // used to test if the value is simply a pathname
    const pathnamePattern = /^\/[a-zA-Z0-9_\-/():]*(\?[\w%&\-=,]+)?$/;

    // used to test if the value is a fully valid URL
    const urlPattern = /^(http|https):\/\/[^ "]+$/;

    if (pathnamePattern.test(returnUrl)) {
        return true;
    }

    if (!urlPattern.test(returnUrl)) {
        return false;
    }

    const url = new URL(returnUrl);

    // prevent open redirects
    if (url.hostname !== window.location.hostname) {
        return false;
    }

    return true;
}

